export default __webpack_public_path__ + "static/media/streaks 30.3b2b7e46.svg";